import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { helper } from 'src/environments/helper';
import { IOperator, IOperatorConfig, IOperatorPermisiuni, IOperatorUpdatePermisiuniPayload, IServiciiDirectie } from '../operatori-proiecte.interface';
import { OperatoriProiecteService } from '../operatori-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, map } from 'rxjs';

@Component({
    selector: 'app-edit-operatori-proiecte',
    templateUrl: './edit-operatori-proiecte.component.html',
    styleUrls: ['./edit-operatori-proiecte.component.scss']
})
export class EditOperatoriProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    selectOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'NU',
            id: 0,
        },
        {
            name: 'DA',
            id: 1,
        },
    ]

    functiiOperator$: Observable<any> = new Observable();
    serviciiIds: number[] = [];
    directiiIds: number[] = [];
    // responsabil: FormControl = new FormControl(-1, [Validators.required, Validators.min(0)]);
    // agent_teren: FormControl = new FormControl(-1, [Validators.required, Validators.min(0)]);

    // form: FormGroup = new FormGroup({
    //     responsabil: this.responsabil,
    //     agent_teren: this.agent_teren,
    // });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IOperator,
        private dialogRef: MatDialogRef<EditOperatoriProiecteComponent>,
        private operatoriProiecteService: OperatoriProiecteService,
        private notificationService: NotificationService,
    ) {
        this.loadPermisiuniOperator();
    }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadPermisiuniOperator() {
        this.isLoading = true;
        this.functiiOperator$ = this.operatoriProiecteService
            .listPermisiuniOperator(this.data.id_user)
            .pipe(
                map((results: { errors: boolean; data: IOperatorPermisiuni; status_code: number }) => {
                    const configData = results.data.config;
                    this.serviciiIds = results.data.operator_allocated.servicii_operator;
                    this.directiiIds = results.data.operator_allocated.directii_operator;

                    // this.responsabil.setValue(results.data.responsabil !== null ? results.data.responsabil : -1);
                    // this.agent_teren.setValue(results.data.agent_teren !== null ? results.data.agent_teren : -1);

                    return configData.map((item: IOperatorConfig) => ({
                        ...item,
                        name: item.label,
                        checked: this.serviciiIds.includes(item.id),
                        directii_types: item.servicii_directie.map((directie: IServiciiDirectie) => ({
                            ...directie,
                            name: directie.label,
                            checked: this.directiiIds.includes(directie.id),
                        })),
                    }));
                }),
                finalize(() => {
                    this.isLoading = false;
                })
            );
    }

    updateCheckedList(type: any, isDirectieType: boolean = false) {
        const id = type.id;
        let arrayToUpdate = isDirectieType ? this.directiiIds : this.serviciiIds;

        if (type.checked) {
            if (!arrayToUpdate.includes(id)) {
                arrayToUpdate.push(id);
            }
        } else {
            const index = arrayToUpdate.indexOf(id);
            if (index > -1) {
                arrayToUpdate.splice(index, 1);
            }
        }
    }

    updatePermisiuniOperator() {
        this.isLoading = true;

        const payload: IOperatorUpdatePermisiuniPayload = {
            directiiIds: this.directiiIds,
            serviciiIds: this.serviciiIds,
            // responsabil: this.responsabil.value,
            // agent_teren: this.agent_teren.value,
        };

        this.operatoriProiecteService
            .updatePermisiuniOperator(this.data.id_user, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
